var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-map-images"},[_c('LadImage',{style:(_vm.customStyles),attrs:{"src":`https://api.mapbox.com/styles/v1/mapbox/${_vm.style}/static/url-${_vm.market}(${_vm.center})/${_vm.center},${_vm.zoom}/${_vm.size}?access_token=${_vm.accessToken}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }